import React from "react";

/**
 * LCRA Logo image with smart background handling.
 * The source PNG has a white background, so on dark surfaces we add a small
 * white pad/box so the logo stays readable.
 */
export default function Logo({ className = "", variant = "auto", size = "md" }) {
  const heights = { sm: "h-8", md: "h-10", lg: "h-12", xl: "h-16" };
  const h = heights[size] || heights.md;

  if (variant === "dark") {
    // For use on dark surfaces — white pill around the logo
    return (
      <div className={`bg-white px-2 py-1 inline-flex items-center ${className}`}>
        <img src="/lcra-logo.png" alt="Lake Cumberland Regional Airport" className={`${h} w-auto`} />
      </div>
    );
  }

  // Default — light surface, no wrapper
  return (
    <img
      src="/lcra-logo.png"
      alt="Lake Cumberland Regional Airport"
      className={`${h} w-auto ${className}`}
    />
  );
}
